import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=4cc4205f&scoped=true&"
import script from "./SkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./SkeletonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=4cc4205f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4205f",
  null
  
)

component.options.__file = "SkeletonLoader.vue"
export default component.exports